import { configure } from '@js-boot/react-i18n';
import deLang from './languages/de.json';
import enLang from './languages/en.json';

export const defaultNS = 'common';
export const resources = {
  de: {
    common: deLang,
  },
  en: {
    common: enLang,
  },
};

export default configure({
  defaultNS,
  resources,
  fallbackLng: 'de',
  overrides: {
    initImmediate: false,
    react: {
      useSuspense: false,
    },
  },
});
